var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { cx: "32", cy: "32", r: "32", fill: "#fff" }),
    React.createElement("circle", { cx: "32.001", cy: "32", r: "26.667", fill: "#FFE9B8", filter: "url(#id-96a)" }),
    React.createElement(
      "mask",
      { id: "id-97b", style: {
          maskType: "alpha"
        }, maskUnits: "userSpaceOnUse", x: "5", y: "5", width: "54", height: "54" },
      React.createElement("circle", { cx: "32.001", cy: "32", r: "26.667", fill: "#fff" })
    ),
    React.createElement(
      "g",
      { mask: "url(#id-97b)" },
      React.createElement("path", { d: "M22.2559 22.2859C22.2559 21.0234 23.2793 20 24.5417 20H38.5746C39.8371 20 40.8605 21.0234 40.8605 22.2859V58.4496H22.2559V22.2859Z", fill: "#FFC95E" }),
      React.createElement("path", { d: "M24.2246 58.4495L40.8913 22.4495L41.5579 58.4495H24.2246Z", fill: "#D69E00" }),
      React.createElement("path", { d: "M12.334 35.9292C12.334 34.6667 13.3574 33.6433 14.6199 33.6433H27.4124C28.6749 33.6433 29.6983 34.6667 29.6983 35.9292V58.4495H12.334V35.9292Z", fill: "#FFF9ED" }),
      React.createElement("path", { d: "M38.3809 44.6113C38.3809 43.3489 39.4043 42.3254 40.6667 42.3254H47.2578C48.5202 42.3254 49.5436 43.3489 49.5436 44.6113V58.4495H38.3809V44.6113Z", fill: "#FFD37D" }),
      React.createElement("path", { d: "M56.0294 20.436C57.9312 24.3876 58.829 28.7472 58.6434 33.1286C58.4579 37.51 57.1946 41.7781 54.9656 45.5547C52.7365 49.3313 49.6105 52.4999 45.8643 54.7797C42.1182 57.0596 37.8676 58.3805 33.4891 58.6253C29.1106 58.87 24.7393 58.0312 20.7624 56.1831C16.7855 54.3349 13.3257 51.5345 10.6896 48.0299C8.05353 44.5253 6.32243 40.4246 5.64966 36.0912C4.97689 31.7577 5.38322 27.3252 6.83267 23.1863L8.96222 23.9321C7.63542 27.7208 7.26347 31.7782 7.87932 35.745C8.49516 39.7118 10.0798 43.4655 12.4928 46.6735C14.9059 49.8816 18.0729 52.4451 21.7133 54.1368C25.3537 55.8286 29.3551 56.5965 33.3632 56.3724C37.3712 56.1483 41.2621 54.9393 44.6913 52.8523C48.1204 50.7653 50.982 47.8648 53.0224 44.4078C55.0628 40.9507 56.2192 37.0438 56.3891 33.0331C56.559 29.0224 55.7371 25.0317 53.9963 21.4145L56.0294 20.436Z", fill: "#FFE9B8" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "id-96a", x: "5.334", y: ".109", width: "53.334", height: "58.558", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
        React.createElement("feOffset", { dy: "-5.224" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2.612" }),
        React.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" }),
        React.createElement("feBlend", { in2: "shape", result: "effect1_innerShadow_3884_7813" })
      )
    )
  );
});